import React from "react";
import { Paper, Stack, Typography, Box } from "@mui/material";

/**
 * Card KPI individual para el Care Manager Overview.
 * Color condicional basado en valor (ej: rojo si > 0 para alertas).
 *
 * @param {{ label, value, icon, color, bgColor, onClick, loading }} props
 */
export default function CMKpiCard({ label, value, icon, color, bgColor, onClick, loading }) {
  if (loading) {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 2,
          borderRadius: 3,
          border: "1px solid",
          borderColor: "divider",
          height: 110,
          animation: "pulse 1.5s infinite",
          "@keyframes pulse": {
            "0%, 100%": { opacity: 1 },
            "50%": { opacity: 0.5 },
          },
        }}
      />
    );
  }

  return (
    <Paper
      elevation={0}
      onClick={onClick}
      sx={{
        p: 2,
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        cursor: onClick ? "pointer" : "default",
        transition: "all 200ms ease",
        "&:hover": onClick
          ? { transform: "translateY(-2px)", boxShadow: "0 4px 12px rgba(0,0,0,0.08)" }
          : {},
      }}
    >
      <Stack spacing={1}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              borderRadius: 2,
              bgcolor: bgColor,
              color,
            }}
          >
            {icon}
          </Box>
          <Typography variant="caption" color="text.secondary" fontWeight={600} sx={{ fontSize: "0.7rem" }}>
            {label}
          </Typography>
        </Stack>
        <Typography variant="h4" fontWeight={800} sx={{ color, lineHeight: 1 }}>
          {value?.toLocaleString() ?? 0}
        </Typography>
      </Stack>
    </Paper>
  );
}
